import React, { useEffect } from "react"
import { Backdrop } from "./backdrop.tsx"

export const OfflinePopup = (props)=>{
  // setRetry state
  const [retry, setRetry] = React.useState(false)

  useEffect(()=>{
    if(retry){
      setTimeout(()=>{
        // setRetry to false
        setRetry(false)
      }, 2000)

    }
  }, [retry])
 


return (
<Backdrop renderafter>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'white'
    }}>
    <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M37.5 0C16.8211 -1.60714e-05 -2.67857e-05 16.821 0 37.5C2.67857e-05 58.1789 16.8211 75 37.5 75C37.5812 75 37.6596 74.9893 37.7405 74.9893C39.2199 74.9893 40.4191 73.79 40.4191 72.3107C40.4191 70.8314 39.2199 69.6321 37.7405 69.6321C37.6618 69.6402 37.5766 69.6429 37.5 69.6429C36.5918 69.6429 35.5424 69.1883 34.2669 67.7856C32.9914 66.3829 31.6614 64.1001 30.5315 61.1624C29.4269 58.2904 28.5099 54.7982 27.8582 50.8928H38.8288C40.3061 50.8899 41.5022 49.6916 41.5022 48.2143C41.5022 46.737 40.3061 45.5386 38.8288 45.5357H27.199C26.9531 42.9521 26.7857 40.2865 26.7857 37.5C26.7857 34.7116 26.9529 32.0488 27.199 29.4643H47.801C48.0472 32.0488 48.2143 34.7116 48.2143 37.5C48.2143 37.9418 48.2127 38.3406 48.2036 38.7765C48.2036 40.2558 49.4081 41.4551 50.8874 41.4551C52.3666 41.4551 53.5658 40.2558 53.5659 38.7765C53.5632 38.3413 53.5685 37.876 53.5713 37.5C53.5713 34.7352 53.4424 32.055 53.2155 29.4643H68.5912C69.2519 32.0365 69.6427 34.7184 69.6427 37.5C69.6427 37.9294 69.6347 38.3518 69.6159 38.7765C69.616 40.2558 70.8204 41.4551 72.2997 41.4551C73.779 41.4551 74.9782 40.2558 74.9783 38.7765C74.9917 38.3492 74.9997 37.9308 74.9997 37.5C74.9997 16.821 58.179 -2.14285e-05 37.5 0ZM37.5 5.35714C38.4082 5.35714 39.4576 5.81688 40.7331 7.21958C42.0086 8.62228 43.3386 10.9051 44.4685 13.8428C45.5726 16.7136 46.4902 20.2051 47.1418 24.1071H27.8582C28.5098 20.2051 29.4274 16.7136 30.5315 13.8428C31.6614 10.9051 32.9914 8.62228 34.2669 7.21958C35.5424 5.81688 36.5918 5.35714 37.5 5.35714ZM28.0099 6.78013C27.0894 8.3076 26.2629 10.0123 25.5301 11.9175C24.1791 15.4302 23.1256 19.5619 22.4226 24.1071H8.2973C12.0788 15.8562 19.2215 9.48267 28.0099 6.78013ZM46.9849 6.78013C55.7755 9.48183 62.9205 15.8547 66.7027 24.1071H52.5722C51.8692 19.5619 50.8209 15.4301 49.4699 11.9175C48.7368 10.0116 47.9058 8.30804 46.9849 6.78013ZM6.40347 29.4643H21.7843C21.5575 32.055 21.4286 34.7352 21.4286 37.5C21.4286 40.2629 21.5577 42.946 21.7843 45.5357H6.40347C5.74323 42.9644 5.35714 40.2805 5.35714 37.5C5.35714 34.7186 5.74283 32.0363 6.40347 29.4643ZM8.2973 50.8928H22.4226C23.1256 55.4415 24.1786 59.5738 25.5301 63.0877C26.2619 64.9903 27.0857 66.6992 28.0047 68.2251C19.218 65.5216 12.0779 59.1429 8.2973 50.8928Z" fill="#88A1AB"/>
<path d="M72.3733 46.8174C71.6969 46.7813 70.98 47.026 70.3487 47.6754L60.9057 57.1184L51.4627 47.6754C50.4101 46.5924 48.6729 46.5922 47.6332 47.6649C46.5941 48.7382 46.616 50.4328 47.675 51.4631L57.118 60.9061L47.675 70.3491C46.592 71.4018 46.5918 73.1441 47.6642 74.1839C48.7374 75.223 50.432 75.1958 51.4624 74.1367L60.9054 64.6937L70.3484 74.1367C72.8736 76.7343 76.7337 72.8742 74.1361 70.3491L64.693 60.906L74.1361 51.463C76.0842 49.5691 74.4026 46.9257 72.3733 46.8174Z" fill="#FF1759"/>
</svg>
<p>You are not connected to the internet</p>


<button style={{
    width: '75%',
    height: '40px',
    backgroundColor: '#008BCD',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    outline: 'none',
    cursor: 'pointer',
    marginTop: '10px'
    
}} onClick={()=>setRetry(true)}>{retry ? "Retrying please wait" : "Retry"}</button>

    </div>
      
      </Backdrop>

)

}